module.exports = __webpack_public_path__ + "js/0.fbcb5153.worker.js"